// 难度等级
const DIFFICULTYLEVEL = {
    1: '容易',
    2: '较易',
    3: '一般',
    4: '较难',
    5: '困难'
}

// 题目类型
const TOPICTYPE = {
    1: '单选',
    2: '多选',
    3: '判断',
    4: '填空',
    5: '主观',
    6: 'scratch程序'
}

// 试卷类型
const TESTPAPERTYPE = {
    1: '正式考试',
    0: '模拟测试',
    // 3: '练习测试'
}

// 试卷状态
const TESTPAPERSTATUS = {
    1: '已上线',
    2: '未上线',
}

// 组卷方式
const ORGANIZETESTPAPERS = {
    1: '手工',
    2: '自动',
    // 3: '随机'
}

// 产品状态
const PRODUCTSTATUS = {
    0: '上架',
    1: '下架'
}

// 产品类型
const PRODUCTTYPE = {
    1: '题库',
    2: '试题'
}

// 激活状态
const ACTICATIONSTATUS = {
    0: '未激活',
    1: '已激活'
}

export {
    DIFFICULTYLEVEL,
    TOPICTYPE,
    TESTPAPERTYPE,
    TESTPAPERSTATUS,
    ORGANIZETESTPAPERS,
    PRODUCTSTATUS,
    PRODUCTTYPE,
    ACTICATIONSTATUS
}


// WEBPACK FOOTER //
// ./src/libs/config.js